<template>
  <section class="hero">
    <div class="hero__inner">
      <div class="hero__eq" aria-hidden="true">
        <span style="height:16px;background:var(--brand-blue)"></span>
        <span style="height:36px;background:var(--brand-pink)"></span>
        <span style="height:24px;background:var(--brand-green)"></span>
        <span style="height:42px;background:var(--brand-red)"></span>
        <span style="height:14px;background:var(--brand-blue)"></span>
      </div>

      <span class="rt-eyebrow hero__eyebrow">TOKYO RIGHTS SERVICE</span>
      <h1 class="hero__title">音楽の、<span class="hero__accent">その先</span>の自由へ。</h1>
      <p class="hero__lead">
        印税管理を、もっと自由に、もっと軽やかに。<br>
        クリエイターと音楽ビジネスに寄り添う会社です。
      </p>
      <div class="hero__ctas">
        <a href="https://www.rights.services" target="_blank" rel="noopener noreferrer" aria-label="rights.services を見る（新しいタブで開きます）" class="rt-btn rt-btn--pink">
          rights.services を見る <i class="fas fa-arrow-up-right-from-square" aria-hidden="true"></i>
        </a>
        <router-link to="/inquiry" class="rt-btn rt-btn--blue-outline">お問い合わせ</router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default { name: 'HomeHero' }
</script>

<style scoped>
.hero {
  position: relative;
  overflow: hidden;
  padding: 132px 24px 80px;
  background:
    radial-gradient(circle at 88% 16%, rgba(238, 134, 168, 0.20), transparent 38%),
    radial-gradient(circle at 12% 88%, rgba(0, 151, 224, 0.15), transparent 42%),
    radial-gradient(circle at 72% 96%, rgba(142, 195, 31, 0.16), transparent 40%);
}

.hero__inner {
  position: relative;
  max-width: 960px;
  margin: 0 auto;
  text-align: left;
}

.hero__eq {
  position: absolute;
  top: 4px;
  right: 4px;
  display: flex;
  gap: 6px;
  align-items: flex-end;
  height: 44px;
}

.hero__eq span {
  width: 8px;
  border-radius: 4px;
  display: block;
}

.hero__eyebrow {
  color: var(--brand-blue);
  background: var(--blue-bg);
}

.hero__title {
  font-size: clamp(32px, 6vw, 48px);
  font-weight: 900;
  line-height: 1.32;
  color: var(--ink);
}

.hero__accent {
  color: var(--brand-pink);
}

.hero__lead {
  font-size: 15px;
  line-height: 1.9;
  color: var(--ink-soft);
  margin: 18px 0 28px;
  max-width: 420px;
}

.hero__ctas {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
</style>
